export default {
    manage_deleteContact_title: "Eliminar contacto",
    manage_deleteContacts_title: "Eliminar contactos",
    manage_deleteContacts_description: "¿Estás seguro de que quieres eliminar los contactos?",
    manage_deleteContact_description: "¿Estás seguro de que quieres eliminar este contacto?",
    manage_deleteContact_successMessage: "Contacto eliminado",
    manage_deleteContacts_successMessage: "Contactos eliminados",
    manage_deleteContacts_are_in_use: "No es posible eliminar contactos en uso",
}